import React from "react";
import { useContainer } from "unstated-next";
import FavoriteMovies from "../../../../store/favorites";
import Tokens from "../../../../store/tokens";
import Tooltip from "../Tooltip";

interface Props {
  inSideDrawer?: boolean;
}

const Logout: React.FC<Props> = (props) => {
  const { logout } = useContainer(Tokens);
  const { resetFavorites } = useContainer(FavoriteMovies);

  const clickLogout = () => {
    logout();
    resetFavorites();
  };

  return (
    <div className="cursor-pointer tooltipParent" onClick={clickLogout}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`h-6 w-6 ml-3 stroke-current ${props.inSideDrawer ? "defaultText" : "text-white"}`}
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
        />
      </svg>
      <Tooltip>Logout</Tooltip>
    </div>
  );
};

export default Logout;
